import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export interface TvTemplateVod {
  template_vod_id: number
  template_id: number
  source: string
  vod_name: string
  broadcast_type: string
  order: number
  is_active: boolean
  created_at: string
}

export interface TvTemplateDevice {
  broadcast_device_id: number
  name?: string
  clinic?: {
    clinic_id: number
    clinic_name: string
  }
}

export interface TvTemplate {
  template_id: number
  template_name: string
  description?: string
  provider_id?: number | null
  created_by?: number
  is_active: boolean
  created_at: string
  updated_at: string
  template_vods: TvTemplateVod[]
  devices?: TvTemplateDevice[]
  _count: { devices: number; template_vods: number }
}

interface UseTvTemplatesParams {
  providerId?: number
}

export function useTvTemplates(params?: UseTvTemplatesParams) {
  const { token } = useAuth()

  // Build query string
  const queryParams = new URLSearchParams()
  if (params?.providerId) queryParams.set('providerId', String(params.providerId))
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data, error, mutate } = useGet<ApiResponse<TvTemplate[]>>(
    token ? `/api/tv-templates${queryString}` : null,
    undefined,
    token ?? '',
  )

  return {
    templates: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function useTvTemplateById(params: { template_id: number | string | null }) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<TvTemplate>>(
    token && params.template_id ? `/api/tv-templates/${params.template_id}` : null,
    undefined,
    token ?? '',
  )

  return {
    template: data?.data || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function useTvTemplateDevices(params: { template_id: number | string | null }) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<
    ApiResponse<
      Array<{
        broadcast_device_id: number
        name?: string
        clinic?: {
          clinic_id: number
          clinic_name: string
        }
      }>
    >
  >(
    token && params.template_id
      ? `/api/tv-templates/${params.template_id}/devices`
      : null,
    undefined,
    token ?? '',
  )

  return {
    devices: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
